export const HOUR_PLACEHOLDER = '__:__';
